module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-bg-light-blue-inot tw-bg-cards-texture tw-rounded tw-p-3 noselect tw-relative tw-flex tw-flex-col tw-h-[350px]",
    attrs: {
      "data-cy": "cy-card-workforce",
      "data-testid": "workforceCard-card"
    }
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-mb-3 tw-text-white"
  }, [_c('div', {
    staticClass: "tw-mr-auto tw-flex tw-flex-col"
  }, [_c('div', {
    staticClass: "tw-font-light tw-text-3xl tw-h-8 tw-mb-1",
    attrs: {
      "data-testid": "workforceCard-title"
    }
  }, [_vm._v("\n                EFFECTIF ÉTUDE\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tw-text-xs"
  }, [_vm._v("\n                Situation au\n                "), _c('span', {
    staticClass: "tw-font-bold",
    attrs: {
      "data-testid": "workforceCard-today-date"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("moment")(new Date(), "DD/MM/YYYY")) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-flex-col tw-items-end"
  }, [_c('div', {
    staticClass: "tw-mb-1"
  }, [_c('Button', {
    attrs: {
      "disabled": !_vm.dataReady,
      "color": "blue",
      "icon": "fa-solid fa-eye",
      "title": "Voir les détails",
      "data-testid": "workforceCard-seeDetail-button"
    },
    on: {
      "click": function($event) {
        _vm.afficherDetails()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-text-xs"
  }, [_c('span', {
    staticClass: "tw-font-bold"
  }, [_vm._v("\n                    " + _vm._s(_vm.effectif.NbrCadres + _vm.effectif.NbrTechniciens + _vm.effectif.NbrEmployes) + "\n                ")]), _vm._v("\n                Salarié" + _vm._s(_vm.effectif.NbrCadres + _vm.effectif.NbrTechniciens + _vm.effectif.NbrEmployes > 1 ? 's' : '') + " dont\n                "), _c('span', {
    staticClass: "tw-font-bold"
  }, [_vm._v("\n                    " + _vm._s(_vm.effectif.NbrCDD) + "\n                ")]), _vm._v("\n                CDD\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-grow tw-overflow-hidden"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "tw-h-full"
  }, [_c('div', {
    staticClass: "tw-grid tw-grid-cols-3 tw-divide-x tw-divide-gray-200/75 tw-text-white"
  }, [_c('div', {
    staticClass: "tw-pr-2",
    attrs: {
      "data-testid": "workforceCard-"
    }
  }, [_c('div', {
    staticClass: "tw-bg-white/10 tw-p-3 tw-rounded",
    attrs: {
      "data-testid": "workforceCard-cadresCount",
      "title": _vm.effectif.NbrCadres > 1 ? _vm.effectif.NbrCadres + ' Cadres' : _vm.effectif.NbrCadres + ' Cadre'
    }
  }, [_c('div', {
    staticClass: "tw-text-lg ellipsis"
  }, [_c('span', {
    staticClass: "tw-font-bold"
  }, [_vm._v(_vm._s(_vm.effectif.NbrCadres))]), _vm._v("\n                            " + _vm._s(_vm.effectif.NbrCadres > 1 ? "Cadres" : "Cadre") + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "tw-text-xs"
  }, [_vm._v("Cat. C1, C2, C3 et C4")])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-px-2"
  }, [_c('div', {
    staticClass: "tw-bg-white/10 tw-p-3 tw-rounded",
    attrs: {
      "data-testid": "workforceCard-card-technicienCount",
      "title": _vm.effectif.NbrTechniciens > 1 ? _vm.effectif.NbrTechniciens + ' Techniciens' : _vm.effectif.NbrCadres + ' Technicien'
    }
  }, [_c('div', {
    staticClass: "tw-text-lg ellipsis"
  }, [_c('span', {
    staticClass: "tw-font-bold"
  }, [_vm._v(_vm._s(_vm.effectif.NbrTechniciens))]), _vm._v("\n                            " + _vm._s(_vm.effectif.NbrTechniciens > 1 ? "Techniciens" : "Technicien") + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "tw-text-xs"
  }, [_vm._v("Cat. T1, T2 et T3")])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-pl-2"
  }, [_c('div', {
    staticClass: "tw-bg-white/10 tw-p-3 tw-rounded",
    attrs: {
      "data-testid": "workforceCard-card-employesCount",
      "title": _vm.effectif.NbrEmployes > 1 ? _vm.effectif.NbrEmployes + ' Employés' : _vm.effectif.NbrCadres + ' Employé'
    }
  }, [_c('div', {
    staticClass: "tw-text-lg ellipsis"
  }, [_c('span', {
    staticClass: "tw-font-bold"
  }, [_vm._v(_vm._s(_vm.effectif.NbrEmployes))]), _vm._v("\n                            " + _vm._s(_vm.effectif.NbrEmployes > 1 ? "Employés" : "Employé") + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "tw-text-xs"
  }, [_vm._v("Cat. E")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-mr-auto tw-flex tw-items-center"
  }, [_c('div', {
    staticClass: "tw-text-white tw-text-xl tw-font-light tw-my-2"
  }, [_vm._v("\n                    DERNIERS MOUVEMENTS DU PERSONNEL\n                ")]), _vm._v(" "), (_vm.dataReady && _vm.effectif !== undefined && _vm.effectif.EntreesSorties.length > 0) ? _c('div', {
    staticClass: "tw-text-xs tw-bg-white/50 tw-text-black tw-px-2 tw-py-1 tw-rounded tw-uppercase tw-font-bold tw-h-[20px] tw-leading-3 tw-ml-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.effectif.EntreesSorties.length) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tw-h-[calc(100%-112px)] tw-w-full"
  }, [(_vm.effectif !== undefined && _vm.effectif.EntreesSorties.length > 0) ? _c('VerticalScroll', [_c('div', {
    staticClass: "tw-w-full tw-divide-y tw-divide-gray-200/75"
  }, _vm._l((_vm.effectif.EntreesSorties), function(entreeSortie) {
    return _c('div', {
      staticClass: "tw-flex tw-items-center tw-py-3",
      class: _vm.effectif.EntreesSorties.length > 1 ? 'first:tw-pt-0 first:tw-pb-3 last:tw-pb-0 last:tw-pt-3' : 'tw-py-0',
      attrs: {
        "title": _vm.getTitleLine(entreeSortie)
      }
    }, [_c('div', {
      staticClass: "tw-flex tw-h-12 tw-rounded tw-w-12 tw-text-white tw-bg-white/10 tw-items-center tw-mr-2 tw-justify-center"
    }, [_c('div', {
      staticClass: "fa-regular tw-text-xl",
      class: entreeSortie.IsEntree ? 'fa-arrow-right-to-bracket tw-text-green-400' : 'fa-arrow-right-from-bracket tw-text-red-400 fa-rotate-180'
    })]), _vm._v(" "), _c('div', {
      staticClass: "tw-flex tw-h-12 tw-rounded tw-p-3 tw-text-white tw-bg-white/10 tw-items-center tw-w-[calc(100%-56px)]"
    }, [_c('div', {
      staticClass: "tw-flex tw-w-[calc(100%-77px)]"
    }, [_c('div', {
      staticClass: "ellipsis"
    }, [_vm._v(_vm._s(entreeSortie.IntituleSalarie) + " - " + _vm._s(entreeSortie.TypeContrat))])]), _vm._v(" "), (entreeSortie.Date) ? _c('div', {
      staticClass: "tw-text-xs tw-bg-white/50 tw-px-2 tw-py-1 tw-rounded tw-text-black tw-ml-2"
    }, [_c('span', {
      staticClass: "tw-font-bold"
    }, [_vm._v(_vm._s(_vm._f("moment")(entreeSortie.Date, "DD/MM/YY")))])]) : _vm._e()])])
  }))]) : _c('div', {
    staticClass: "tw-full tw-flex tw-flex-col tw-justify-center tw-items-center"
  }, [_c('div', {
    staticClass: "fa-stack fa-2x tw-mb-2"
  }, [_c('span', {
    staticClass: "fa-solid fa-circle fa-stack-2x tw-text-white/10"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa-light fa-empty-set fa-stack-1x fa-inverse tw-text-white"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tw-text-white"
  }, [_vm._v("Aucun mouvement")])])], 1)]) : _c('div', {
    staticClass: "tw-animate-pulse"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-full tw-divide-y tw-divide-gray-200 tw-overflow-hidden tw-mt-3"
  }, _vm._l((3), function(n) {
    return _c('div', {
      staticClass: "tw-py-3 first:tw-pt-0 first:tw-pb-3 last:tw-pb-0 last:tw-pt-3 tw-divide-gray-200"
    }, [_c('div', {
      staticClass: "tw-bg-gray-200 tw-h-12 tw-w-full tw-rounded"
    })])
  }))])]), _vm._v(" "), _c('modalCardWorkforce', {
    attrs: {
      "effectif": _vm.effectif
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-grid tw-grid-cols-3 tw-divide-x tw-divide-gray-200"
  }, [_c('div', {
    staticClass: "tw-pr-2"
  }, [_c('div', {
    staticClass: "tw-bg-gray-200 tw-rounded tw-h-[68px]"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tw-px-2"
  }, [_c('div', {
    staticClass: "tw-bg-gray-200 tw-rounded tw-h-[68px]"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tw-pl-2"
  }, [_c('div', {
    staticClass: "tw-bg-gray-200 tw-rounded tw-h-[68px]"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-mt-3"
  }, [_c('div', {
    staticClass: "tw-bg-gray-200 tww-64 tw-rounded tw-h-5"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b8ff25c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/cards/cardWorkforce/cardWorkforce.vue.html
// module id = Htav
// module chunks = 2